import { createEntityAdapter } from '@reduxjs/toolkit'
import { apiSlice } from '../../app/services/apiSlice'

const reqTypeAdapter = createEntityAdapter()
const reqClientTypeAdapter = createEntityAdapter()
const totalReqAdapter = createEntityAdapter()
const deptUserAdapter = createEntityAdapter()

const initialReqType = reqTypeAdapter.getInitialState()
const initialClientReqType = reqClientTypeAdapter.getInitialState()
const initialTotalReq = totalReqAdapter.getInitialState()
const initialDeptUser = deptUserAdapter.getInitialState()

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getReqType: builder.query({
      query: body => ({
        url: '/api/setcmmcode',
        method: 'POST',
        body,
      }),
      transformResponse: response => {
        const [{ cmmCodList }] = response
        let results = cmmCodList.map((result, index) => {
          return {
            id: index + 1,
            ...result,
          }
        })
        results = [{ id: 0, cmmCodCl: '', cmmCodNm: '전체' }, ...results]
        return reqTypeAdapter.setAll(initialReqType, results)
      },
      providesTags: ['ReqType'],
    }),
    getClientReqType: builder.query({
      query: params => ({
        url: '/approval/serviceprogress/getReqCl',
        params,
      }),
      transformResponse: response => {
        let results = response.map((result, index) => {
          return {
            id: index,
            ...result,
          }
        })
        // results = [{ id: 0, reqCl: '', reqClNm: '전체' }, ...results]
        return reqTypeAdapter.setAll(initialClientReqType, results)
      },
      providesTags: ['ClientReqType'],
    }),
    getTotalRequestList: builder.query({
      query: params => ({
        url: '/stats/tot/list',
        params,
      }),
      transformResponse: response => {
        let results = response.map((result, index) => {
          return {
            id: index,
            ...result,
          }
        })
        // results = [{ id: 0, reqCl: '', reqClNm: '전체' }, ...results]
        return totalReqAdapter.setAll(initialTotalReq, results)
      },
      providesTags: ['TotalRequestList'],
    }),
    getDeptUserList: builder.query({
      query: params => ({
        url: '/system/servicedeptuser',
        params,
      }),
      transformResponse: response => {
        let results = response.map((result, index) => {
          return {
            id: index,
            ...result,
          }
        })
        return deptUserAdapter.setAll(initialDeptUser, results)
      },
      providesTags: ['DeptUserList'],
    }),
  }),
})

export const {
  useGetReqTypeQuery,
  useGetClientReqTypeQuery,
  useGetTotalRequestListQuery,
  useGetDeptUserListQuery,
} = extendedApiSlice
